<script lang="ts" setup></script>

<template>
  <svg
    id="Zakladniprvky_Sipka_Galerie"
    xmlns="http://www.w3.org/2000/svg"
    width="34.199"
    height="7.809"
    viewBox="0 0 34.199 9.809"
  >
    <g id="Group_1146" data-name="Group 1146" transform="translate(0 4.905)">
      <g id="Group_65" data-name="Group 65">
        <path id="Path_36" data-name="Path 36" d="M0,0H30" stroke-width="1" />
      </g>
    </g>
    <g id="Group_67" data-name="Group 67" transform="translate(29.999, 1)">
      <path id="Path_38" data-name="Path 38" d="M0,0V7.809l4.2-3.9Z" />
    </g>
  </svg>
</template>
